import Vue from 'vue'
import Vuex from 'vuex'

import Cookies from 'js-cookie'
import { getLanguage } from '@/i18n/index'

import { userLogin, logout, getInfo } from '@/api/user'
import { getToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

import $token from '@/utils/token'

function getTemType() {
  const temType = Cookies.get('temType') || 'ssd'
  return temType
}

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isCollapse: false,// 菜单的伸缩
    token: getToken(),
    userInfo: {},
    roles: [],// 菜单
    routes: [],// 动态生成的路由变
    logs: [],
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: getLanguage(),
    temType: getTemType(),
    size: Cookies.get('size') || 'medium',
    map: Cookies.get('map') || 'ggMap',
    allDeviceSort: Cookies.get('allDeviceSort') ? Cookies.get('allDeviceSort') : '-1',
    timezone: Cookies.get('timezone') ? Cookies.get('timezone') : '',
    yhubmqtt: Cookies.get('yhubmqtt') ? Cookies.get('yhubmqtt') : '',
    webInfo: Cookies.get('webInfo') ? Cookies.get('webInfo') : {},
    deviceInfo: Cookies.get('deviceInfo') ? Cookies.get('deviceInfo') : {},
    deviceRealtimeData: Cookies.get('deviceRealtimeData') ? Cookies.get('deviceRealtimeData') : {},
    apiDeviceRealtimeData: Cookies.get('apiDeviceRealtimeData') ? Cookies.get('apiDeviceRealtimeData') : {},
    chargerOption: Cookies.get('chargerOption') ? Cookies.get('chargerOption') : [], // 充电记录事件下拉框数据
    companyOption: [], // 扁平结构的所有公司
    companyTreeOption: [], // 树状结构的所有公司
    name: '',
    avatar: '',
    introduction: '',
    menus: [],
    company: {},
    companyId: 0,
    isAdmin: false, // 是否是管理员
    /*
    1.superAdmin-超级管理员（GPD）:全部公司全部权限 id=4&&sysAdminFlag=true
    2.superAdmin-超级管理员（非GPD）:自己公司全部权限 id!=4&&sysAdminFlag=true (暂时无用，后来判断)
    3.admin-普通管理员/非一般用户：自己公司的高级权限（真数据，可编辑） sysAdminFlag=false&&guestFlag=false
    4.commonUser-一般用户：自己公司的只读权限（真数据，不可编辑） userName!='guest'&&guestFlag=true
    5.guest-访客：只读权限（假数据，不可编辑） userName=='guest'
    */
    role: '' // 权限--cici 2022.9
  },
  mutations: {
    changeCollapse: (state) => { // 侧边栏伸缩
      state.isCollapse = !state.isCollapse
    },
    SET_ROLES: (state, roles) => { // 菜单
      state.roles = roles
    },
    SET_TOKEN: (state, token) => { // token
      state.token = token
      $token.set(token)
    },
    set_userInfo: (state, data) => { // 用户信息
      state.userInfo = data
    },
    SET_ROUTES: (state, accessRoutes) => { // 路由
      state.routes = accessRoutes
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_TEMTYPE: (state, temType) => {
      state.temType = temType
      Cookies.set('temType', temType)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    SET_MAP: (state, map) => {
      state.map = map
      Cookies.set('map', map)
    },
    SET_TIMEZONE: (state, timezone) => {
      state.timezone = timezone
      Cookies.set('timezone', timezone)
    },
    SET_YHUBMQTT: (state, yhubmqtt) => {
      state.yhubmqtt = yhubmqtt
      Cookies.set('yhubmqtt', yhubmqtt)
    },
    SET_WEBINFO: (state, webInfo) => {
      state.webInfo = webInfo
      Cookies.set('webInfo', webInfo)
    },
    SET_deviceInfo: (state, deviceInfo) => {
      state.deviceInfo = deviceInfo
      Cookies.set('deviceInfo', deviceInfo)
    },
    SET_deviceRealtimeData: (state, deviceRealtimeData) => {
      state.deviceRealtimeData = deviceRealtimeData
      Cookies.set('deviceRealtimeData', deviceRealtimeData)
    },
    SET_apiDeviceRealtimeData: (state, apiDeviceRealtimeData) => {
      state.apiDeviceRealtimeData = apiDeviceRealtimeData
      Cookies.set('apiDeviceRealtimeData', apiDeviceRealtimeData)
    },
    SET_allDeviceSort: (state, allDeviceSort) => {
      state.allDeviceSort = allDeviceSort
      Cookies.set('allDeviceSort', allDeviceSort, { expires: 365 })
    },
    SET_ChargerOption: (state, chargerOption) => {
      state.chargerOption = chargerOption
      Cookies.set('chargerOption', chargerOption, { expires: 365 })
    },
    SET_CompanyTreeOption (state, data) {
      state.companyTreeOption = data
    },
    SET_CompanyOption (state, data) {
      state.companyOption = data
    },
    ADD_ERROR_LOG: (state, log) => {
      state.logs.push(log)
    },
    CLEAR_ERROR_LOG: (state) => {
      state.logs.splice(0)
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_COMPANY: (state, company) => {
      state.company = company
      state.companyId = company.id
    },
    SET_MENUS: (state, data) => {
      state.menus = data
    },
    SET_ISADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_ROLE: (state, role) => {
      state.role = role
    }
  },
  getters: {
    getChargerOption (state) {
      return state.chargerOption
    },
    userInfo: state => state.userInfo
  },
  actions: {
    toggleSideBar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar ({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice ({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setTemType ({ commit }, temType) {
      commit('SET_TEMTYPE', temType)
    },
    setSize ({ commit }, size) {
      commit('SET_SIZE', size)
    },
    setMap ({ commit }, map) {
      commit('SET_MAP', map)
    },
    setTimezone ({ commit }, timezone) {
      commit('SET_TIMEZONE', timezone)
    },
    setYhubmqtt ({ commit }, yhubmqtt) {
      commit('SET_YHUBMQTT', yhubmqtt)
    },
    setWebInfo ({ commit }, webInfo) {
      commit('SET_WEBINFO', webInfo)
    },
    setDeviceInfo ({ commit }, deviceInfo) {
      commit('SET_deviceInfo', deviceInfo)
    },
    setDeviceRealtimeData ({ commit }, deviceRealtimeData) {
      commit('SET_deviceRealtimeData', deviceRealtimeData)
    },
    setApiDeviceRealtimeData ({ commit }, apiDeviceRealtimeData) {
      commit('SET_apiDeviceRealtimeData', apiDeviceRealtimeData)
    },
    setAllDeviceSort ({ commit }, allDeviceSort) {
      commit('SET_allDeviceSort', allDeviceSort)
    },
    setChargerOption ({ commit }, chargerOption) {
      commit('SET_ChargerOption', chargerOption)
    },
    setCompanyTreeOption ({ commit }, companyTreeOption) {
      commit('SET_CompanyTreeOption', companyTreeOption)
    },
    setCompanyOption ({ commit }, companyOption) {
      commit('SET_CompanyOption', companyOption)
    },
    addErrorLog ({ commit }, log) {
      commit('ADD_ERROR_LOG', log)
    },
    clearErrorLog ({ commit }) {
      commit('CLEAR_ERROR_LOG')
    },
    login ({ commit }, userInfo) {
      const { username, password } = userInfo
      return new Promise((resolve, reject) => {
        userLogin({ userName: username.trim(), password: password }).then(res => {
          console.log('登录：', res)
          if (res.resultCode === 1001) {
            commit('SET_TOKEN', res.resultModel)
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          console.log('用户：', res)
          if (res.resultCode == 1001) {
            console.log(12)
            resolve(res)
            const data = res.resultModel
            commit('SET_ROLES', data.roles)
            commit('SET_ISADMIN', data.sysAdminFlag)
            commit('SET_NAME', data.name)
            commit('SET_AVATAR', data.avatar)
            commit('SET_MENUS', data.menus)
            commit('SET_COMPANY', data.companyInfo)
            commit('SET_USERINFO', data.currentUserInfo)
            data.companyInfo.userName = data.userName
            sessionStorage.setItem('companyInfo', JSON.stringify(data.companyInfo))
            var role = ''
            if (data.sysAdminFlag) {
              role = 'superAdmin'
            } else if (data.userName == 'guest') {
              role = 'guest'
            } else if (data.userName != 'guest' && data.guestFlag) {
              role = 'commonUser'
            } else if (!data.sysAdminFlag && !data.guestFlag) {
              role = 'admin'
            }
            // SET_ROLE
            commit('SET_ROLE', role)
          } else {
            console.log(13)
            reject(res)
          }

        }).catch(error => {
          reject(error)
        })
      })
    },
    logout ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_ISADMIN', false)
          // removeToken()
          resetRouter()

          $token.remove()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('delAllViews', null, { root: true })

          resolve()
          // window.location.reload()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // remove token
    resetToken ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_ISADMIN', false)
        // removeToken()
        resolve()
      })
    },

    // dynamically modify permissions
    changeRoles ({ commit, dispatch }, role) {
      return new Promise(async resolve => {
        const token = role + '-token'

        commit('SET_TOKEN', token)
        // setToken(token)

        const { roles } = await dispatch('GetUserInfo')

        resetRouter()

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('generateRoutes', roles, { root: true })

        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views
        dispatch('delAllViews', null, { root: true })

        resolve()
      })
    }
  }
})

export default store
